import { createStore, createLogger } from 'vuex'
import createPersistedstate from 'vuex-persistedstate'//持久化数据状态，防止刷新vuex数据丢失
import systemManage from './modules/systemManage'
import globalParams from './modules/globalParams'

let debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules: {
    systemManage,
    globalParams,
  },
  strict: debug,
  plugins: [createPersistedstate({
    key: "vuex",
  })],
})